module.exports = __webpack_public_path__ + "img/evoluq_logo_color.b46ac710.svg";